<template>
    <div>
        <img src="https://raw.githubusercontent.com/ShineShineDev/ShineShineDev/55f9002887e4a0cbb513502045b1734b2f2fbe67/imgs/loading.svg" class="card-img-top loading-img-one" />
        <img src="https://raw.githubusercontent.com/ShineShineDev/ShineShineDev/55f9002887e4a0cbb513502045b1734b2f2fbe67/imgs/loading.svg" class="card-img-top loading-img-two" />
        <img src="https://raw.githubusercontent.com/ShineShineDev/ShineShineDev/55f9002887e4a0cbb513502045b1734b2f2fbe67/imgs/loading.svg" class="card-img-top loading-img-three" />
        <img src="https://raw.githubusercontent.com/ShineShineDev/ShineShineDev/55f9002887e4a0cbb513502045b1734b2f2fbe67/imgs/gear.svg"  class="card-img-top code-gear-loading" />
    </div>
</template>

<script>
    export default {
        name : 'Pending',
        data() {
		return {
			host: process.env.VUE_APP_HOST,
		};
	},
    }

</script>

<style scoped>

/* loading image one */
.loading-img-one {
  height: 180px;
  animation: 5s rotating-img infinite;
}

/* loading image two */
.loading-img-two {
  height: 140px;
  position: relative;
  top: -158px;
  animation: 5s rotating-img-reverse infinite;
}

/* loading image three */
.loading-img-three {
  height: 100px;
  position: relative;
  top: -280px;
  animation: 5s rotating-reverse infinite;
}

/* gear loading image  */
.code-gear-loading {
  height: 70px;
  position: relative;
  top: -365px;
  animation: 7s rotating-img-reverse infinite;
}

@keyframes rotating-img{
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
@keyframes rotating-img-reverse {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(-360deg);
  }
}

</style>